/**
 * @flow
 */

import React from "react"
import styled from "styled-components"

type Props = {
  src: Object,
  maxWidth: number,
  maxHeight: number,
}

const Container = styled.div`
  img {
    width: ${props => `${props.maxWidth}px`};
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
`

const Gif = ({ src, ...props }: Props) => {
  return (
    <Container {...props}>
      <img src={src} alt="Teamgeek 2019" />
    </Container>
  )
}

export default Gif
